export enum DateRange {
    Inmediate,
    CurrentWeek
}